import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type VeracodeConnectorConfig = typeof VeracodeConnector._.Config;

export const VeracodeConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Veracode,
  logoPath: 'images/veracode-logo.svg',
  categories: [IntegrationConnectorCategory.Security],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ApiKey,
      configSchema: z.object({
        baseUrl: z.url().optional(),
        apiId: z.string().trim().min(1),
      }),
      encryptedConfigSchema: z.object({
        apiKey: z.string().trim().min(1),
      }),
    }),
  ]),
});
